import { render, staticRenderFns } from "./assetfrmga.vue?vue&type=template&id=67bda904"
import script from "./assetfrmga.vue?vue&type=script&lang=js"
export * from "./assetfrmga.vue?vue&type=script&lang=js"
import style0 from "./assetfrmga.vue?vue&type=style&index=0&id=67bda904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports